import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="privacy" data-testid="privacy-page">
      <div className="wrap privacy-container">
        <div className="privacy-header">
          <h1>Privacy Policy</h1>
          <p className="privacy-updated">Last updated October 2026</p>
        </div>

        <section className="privacy-section">
          <h2>Information We Collect</h2>
          <p>When you contact us through our website, we collect information you provide directly to us, including:</p>
          <ul>
            <li>Name (first and last)</li>
            <li>Email address</li>
            <li>Company name</li>
            <li>Service interests</li>
            <li>Project details and messages</li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2>How We Use Your Information</h2>
          <p>We use the information we collect to:</p>
          <ul>
            <li>Respond to your inquiries and provide customer support</li>
            <li>Communicate with you about our services</li>
            <li>Improve our website and services</li>
            <li>Comply with legal obligations</li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2>Information Sharing</h2>
          <p>We do not sell, trade, or rent your personal information to third parties. We may share your information with:</p>
          <ul>
            <li>Service providers who assist in our operations (e.g., email services, form processors)</li>
            <li>Professional advisors when necessary</li>
            <li>Law enforcement when required by law</li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2>Data Security</h2>
          <p>We implement appropriate technical and organizational measures to protect your personal information. However, no method of transmission over the Internet is 100% secure.</p>
        </section>

        <section className="privacy-section">
          <h2>Cookies and Analytics</h2>
          <p>We use Cookiebot to ask for your consent before setting any non-essential cookies. Cookiebot stores your choice in a cookie so we can remember it on later visits. You can change or withdraw your consent at any time through the cookie banner.</p>
          <p>If you accept statistics cookies, we use PostHog to understand how visitors use the site. PostHog collects usage data such as pages viewed, device and browser type, approximate location based on IP address, and session recordings of your interactions with the site. PostHog stores this data in the United States. If you decline, PostHog does not load.</p>
        </section>

        <section className="privacy-section">
          <h2>Cloudflare Turnstile</h2>
          <p>Our contact form uses Cloudflare Turnstile for security purposes. Cloudflare may collect certain information as described in their privacy policy.</p>
        </section>

        <section className="privacy-section">
          <h2>Your Rights</h2>
          <p>You have the right to:</p>
          <ul>
            <li>Access the personal information we hold about you</li>
            <li>Request correction of inaccurate information</li>
            <li>Request deletion of your information</li>
            <li>Opt-out of marketing communications</li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2>Contact Us</h2>
          <p>If you have questions about this Privacy Policy or our data practices, please contact us at:</p>
          <p><strong>Email:</strong> inquire@rapidrune.com</p>
        </section>

        <div className="privacy-back">
          <a href="/" className="link-arrow" data-testid="privacy-back-link">
            Back to home
          </a>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
